<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>

    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text"> My Account Help</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex>
            <v-container  fluid grid-list-xl >
              <v-layout style="margin-bottom:10px" justify-start row wrap>
                <v-flex>
                  <h2  class="subheading font-weight-medium">
                      This section is where you can view all the orders that have been made by the customers. It is broken down into 2 main sections In-Progress or Shipped. You can also choose to view all of the orders together ordered by date. All of the orders made by the customers would have to be manually shipped by a seller.
                  </h2>
                </v-flex>
              </v-layout>
            </v-container>

            <!----------------------  EDIT PROFILE   -------------------->
            <v-layout class="mb-1">
              <v-flex>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Edit Profile</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Navigate to Update Profile
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/account/NavigatetoUpdateProfile.jpg" style="height:600px;max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Make the changes to your profile fields.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/account/EditProfile.jpg" style="max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click SAVE.
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

            <!----------------------  EDIT PASSWORD   -------------------->
            <v-layout >
              <v-flex>
                <v-expansion-panel >
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div> <h1 class="title font-weight-bold">Edit Password</h1></div>
                    </template>
                    <v-card>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              1
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Navigate to Change Password
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/account/NavigateToChangePassword.jpg" style="height:600px;max-width:60%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              2
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Type in the current password at the top.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/account/TypeInCurrentPassword.jpg" style="max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              3
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Type in the new password you wish to change to.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/account/TypeInNewPassword.jpg" style="max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              4
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Confirm the new password by typing it again on the last field.
                            </h3>
                            <div class="mb-5 mt-4">
                              <img src="/static/img/help/account/ConfirmNewPassword.jpg" style="max-width:90%;" />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap >
                          <v-flex xs2 md1 class="text-xs-center">
                            <div class="round-number">
                              5
                            </div>
                          </v-flex>
                          <v-flex xs10 md11 class="text-xs-left pt-2">
                            <h3 class="subheading font-weight-bold">
                              Click CHANGE PASSWORD.
                            </h3>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'

export default {
  data () {
    return {
      drawer: false
    }
  },
  components: {
    SideDrawer
  },
  mounted () {
    this.openDrawerForDesktop()
  }
}
</script>

<style scoped>

.round-number {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #ff0000;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding-top: 3px;
}

.box-shadow{
 box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
}

</style>
